import { api } from './utils';

export const subscriptionsAPI = {
  // GET /api/subscriptions/status
  getStatus: () => api.get('/api/subscriptions/status'),

  // POST /api/subscriptions/cancel
  cancel: (data) => api.post('/api/subscriptions/cancel', data),

  // POST /api/subscriptions/update-plan
  updatePlan: (data) => api.post('/api/subscriptions/update-plan', data),

  // POST /api/subscriptions/create-billing-portal
  createBillingPortal: () => api.post('/api/subscriptions/create-billing-portal'),

  // GET /api/subscriptions/reactivation-status
  getReactivationStatus: () => api.get('/api/subscriptions/reactivation-status'),

  // POST /api/subscriptions/create-reactivation-checkout
  createReactivationCheckout: (planName) => api.post('/api/subscriptions/create-reactivation-checkout', { planName }),

  // GET /api/signup/plans (with email parameter for free plan access)
  getPlans: (email) => api.get('/api/signup/plans', { email }),
};
